export default __webpack_public_path__ + "831e2c32c57181a0821e2d65ac3362fc.png";